export class GroupInactivateModal extends HTMLElement {
  constructor(group, inactivate_callback) {
    super();
    this.group = group;
    this.inactivate_callback = inactivate_callback;
  }

  connectedCallback() {
    this.innerHTML = `
    <style>
      add-location-modal {
        font-size: 14px;
      }

      .inactivate_notes_container {
        margin-top: 20px;
      }
    </style>
    <div class="btn-group pull-right" >
      <a data-toggle="dropdown" class="btn btn-outline-secondary dropdown-toggle"> <span class="fa fa-ellipsis-h fa-lg"></span></a>
      <ul class="dropdown-menu caret-off" role="menu" aria-labelledby="dLabel">
        <li><a id="group_show_inactivate" href="#">Deactivate Group</a></li>                                             
      </ul>
    </div>
    <div class="modal fade" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirm</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body row">
            <div class="col-sm-12">
              <p>You are about to deactivate the group ${this.group.name}. This will also deactivate any sub groups and locations. All campaigns will be paused for 30 days before getting fully deleted.</p>
              <p>Do you want to continue?</p>
            </div>
            <div class="col-sm-6">
              <select class="form-control">
                <option value="0">Select</option>
                <option value="1">Yes, Deactivate group now</option>
                <option value="2">Yes, Schedule Deactivation on →</option>
              </select>
            </div>
            <div class="col-sm-6">
              <input type="text" class="form-control hidden" id="inactivation_date">
            </div>
            <div class="col-sm-12 inactivate_notes_container">
              <textarea class="form-control" id="inactivate_group_notes" placeholder="Enter deactivation note"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" id="group_inactivate_cancel" class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
            <button type="button" id="group_inactivate_confirm" class="btn btn-outline-primary" disabled>Ok</button>
          </div>
        </div>
      </div>
    </div>`


    this.querySelector("#group_show_inactivate").addEventListener("click", (e) => {
      e.preventDefault(); 
      $(this.querySelector(".modal")).modal("show")
    });

    $(this).find('.modal').on('hidden.bs.modal', function () {
      //this.reset();
    }.bind(this));

    this.cancellation_date = moment().add(1, "days").format('YYYY-MM-DD');
    $(this).find("#inactivation_date").daterangepicker(
      {
        autoApply: true,
        minDate: moment().add(1,'days'),
        singleDatePicker: true
      },
      function (start) {
        this.cancellation_date = start.startOf("day").format('YYYY-MM-DD');
      }.bind(this)
    );

    this.querySelector("select").addEventListener("change", (e) => {
      console.log(e.target.value)
      if(e.target.value == "0") {
        this.querySelector("#group_inactivate_confirm").setAttribute("disabled", "true")
      } else {
        this.querySelector("#group_inactivate_confirm").removeAttribute("disabled")
        this.querySelector("#inactivation_date").classList.add("hidden");
        if(e.target.value == "2") {
          this.querySelector("#inactivation_date").classList.remove("hidden");
        }
      }
    });

    this.querySelector("#group_inactivate_confirm").addEventListener("click", (e) => {this.inactivateGroup(); e.target.setAttribute("disabled", "true")})
  }

  async inactivateGroup() {
    console.log(this.cancellation_date)
    let body = {};
    if(this.querySelector("select").value == "2") {
      body.inactivation_date = this.cancellation_date;
    }
    body.notes = this.querySelector("#inactivate_group_notes").value;

     let resp = await (fetch(`/admin/groups/${this.group.id}/inactivate`, {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-Type': 'application/json'},
          method: 'POST',
          body:  JSON.stringify(body)
        }).catch(handleError))
      
      this.querySelector("#group_inactivate_confirm").removeAttribute("disabled");

      let json = await resp.json();
      if(resp.ok && json.success) {
        Common.notify('Group successfully deactivated', 'success');
        $(this.querySelector(".modal")).modal("hide");
        this.inactivate_callback();
      }
      else {
        if(json.error == null) {
          Common.notify('Failed to inactivate group.', 'error');
        } else {
          Common.notify(json.error, 'error');
        }
      }
  }
}

customElements.define("group-inactivate-modal", GroupInactivateModal);

export class GroupReactivate extends HTMLElement {
  constructor(group, permissions, reactivate_callback) {
    super();
    this.group = group;
    this.permissions = permissions;
    this.reactivate_callback = reactivate_callback;
  }

  connectedCallback() {
    let alreadyInactive = moment.utc(this.group.inactive_date).isBefore(moment.utc());
    let username = this.group.deactivation_user.user_profile.first_name && this.group.deactivation_user.user_profile.last_name ?
      `${this.group.deactivation_user.user_profile.first_name} ${this.group.deactivation_user.user_profile.last_name}` : 
      this.group.deactivation_user.email;
    this.innerHTML = `
    <div class="col-xs-12">
        <div class="alert alert-danger" role="alert">
          ${this.permissions.includes("admin:accounting:can_activate_group") && !this.group.is_parent_inactive ? `
          <div class="btn-group pull-right">
            <a data-toggle="dropdown" class="btn btn-link dropdown-toggle pull-right" style="color:gray"> <span class="fa fa-ellipsis-h fa-lg"></span></a>
            <ul class="dropdown-menu caret-off" role="menu">
              <li><a id="group_reactivate" href="#">Reactivate</a></li>                                                                                      
            </ul>
          </div>
          ` : ``}
          ${alreadyInactive ? `
              <strong>This was deactivated on ${moment.utc(this.group.inactive_date).format('MM/DD/YYYY')} by ${username}.</strong>
              <p>Notes: ${this.group.notes != null ? this.group.notes : 'none'}</p>
            ` : 
            `
              <strong>This group will be deactivated in ${moment.utc(this.group.inactive_date).diff(moment.utc(), 'days')+1} days.</strong> 
          `}
        </div>
      </div>`

    if(this.permissions.includes("admin:accounting:can_activate_group") && !this.group.is_parent_inactive) {
      this.querySelector("#group_reactivate").addEventListener("click", ()=> {this.reactivateGroup()})
    }
  }

  async reactivateGroup() {
    
    if(await confirmPlus("Are you sure you want to reactivate ")) {
     let resp = await (fetch(`/admin/groups/${this.group.id}/activate`, {
            headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                    'Content-Type': 'application/json'},
            method: 'POST',
          }).catch(handleError))
        
        let json = await resp.json();
        if(resp.ok && json.success) {
          Common.notify('Group successfully activated', 'success');
          this.reactivate_callback();
        }
        else {
          if(json.error == null) {
            Common.notify('Failed to activate group.', 'error');
          } else {
            Common.notify(json.error, 'error');
          }
        }
    }
  }
}

customElements.define("group-reactivate", GroupReactivate);